import {brandConfigMap, getBrandConfig} from "@/brand";
import store from "@/store";
import {Brands} from "@/brand/brandConfig";

export function setBrandConfig() {
    const domain = window.origin;
    const urlParams = new URLSearchParams(window.location.search);
    const network = urlParams.get('nt');
    const domainBrandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');

    let brandConfig;

    // Keep explicit domain mappings, like Rugga Nation, from being overridden by generic network selection.
    if (domainBrandConfig.brand === Brands.WorldPlayRuggaNationSouthAfricaEnglish) {
        brandConfig = domainBrandConfig;
    } else if (network === 'MTN') {
        brandConfig = getBrandConfig(Brands.MTNWorldPlaySouthAfticaEnglish);
    } else if (network === 'Telkom') {
        brandConfig = getBrandConfig(Brands.TelkomWorldPlaySouthAfticaEnglish);
    } else {
        // Fall back to domain-based configuration if no network parameter
        brandConfig = domainBrandConfig;
    }

    store.commit('setBrandConfig', brandConfig);
    document.title = brandConfig.gameTitle || 'Rugby Zone';
    console.log(brandConfig);

    const brandStyles = require(`../brand/${brandConfig.brand}/styles/index.js`).styles;
    const brandStyleSheet = document.createElement('style');

    let brandStyleInnerHTML = '';

    brandStyles.backgrounds.forEach((background) => {
        brandStyleInnerHTML += ` .${background.className} { background-color: ${background.colour} }`;
    });

    brandStyles.text.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { color: ${textItem.colour} }`;
    });

    if (brandConfig.brand === 'wp-za-en' || brandConfig.brand === 'mtn-wp-za-en' || brandConfig.brand === 'telkom-wp-za-en' || brandConfig.brand === 'wp-rn-za-en') {
        if (brandStyles.contextualText && Array.isArray(brandStyles.contextualText)) {
            brandStyles.contextualText.forEach((contextItem) => {
                const parent = contextItem.parentClassName;
                const child = contextItem.className;
                const colour = contextItem.colour;
                const fontWeight = contextItem.fontWeight;
                const fontStyle = contextItem.fontStyle;
                const textDecoration = contextItem.textDecoration;
                let extra = '';
                if (fontWeight) extra += `; font-weight: ${fontWeight}`;
                if (fontStyle) extra += `; font-style: ${fontStyle}`;
                if (textDecoration) extra += `; text-decoration: ${textDecoration}`;
                brandStyleInnerHTML += ` .${parent}.${child}, .${parent} .${child} { color: ${colour}${extra} }`;
            });
        }
    }

    brandStyles.borders.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { border: 1.5px solid ${textItem.colour} }`;
    });

    if (brandStyles.appBackground) {
        brandStyleInnerHTML += ` .vue-container { background-image: none; background-color: ${brandStyles.appBackground} }`;
    }

    brandStyleSheet.innerHTML = brandStyleInnerHTML;
    document.body.appendChild(brandStyleSheet);

    if (brandConfig.brand === 'vc-za-en') {
        injectBeastStyles();
    }
}

function injectBeastStyles() {
    const style = document.createElement('style');
    style.innerHTML = `
        @font-face { font-family:'Poppins'; font-weight:100; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-Thin.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:100; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-ThinItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:200; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-ExtraLight.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:200; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-ExtraLightItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:300; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-Light.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:300; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-LightItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:400; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-Regular.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:400; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-Italic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:500; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-Medium.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:500; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-MediumItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:600; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-SemiBold.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:600; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-SemiBoldItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:700; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-Bold.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:700; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-BoldItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:800; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-ExtraBold.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:800; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-ExtraBoldItalic.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:900; font-style:normal; font-display:swap; src:url('/fonts/poppins/Poppins-Black.ttf') format('truetype'); }
        @font-face { font-family:'Poppins'; font-weight:900; font-style:italic; font-display:swap; src:url('/fonts/poppins/Poppins-BlackItalic.ttf') format('truetype'); }

        @keyframes screen-in {
            from { opacity:0; transform:translate3d(0,16px,0) scale(.982); filter:blur(3px); }
            60%  { opacity:1; filter:blur(0); }
            to   { opacity:1; transform:none; filter:blur(0); }
        }
        @keyframes head-in {
            from { opacity:0; transform:translate3d(0,-10px,0); }
            to   { opacity:1; transform:none; }
        }
        @keyframes body-in {
            from { opacity:0; transform:translate3d(0,22px,0); }
            to   { opacity:1; transform:none; }
        }
        @keyframes wipe-in {
            from { transform:translate3d(-101%,0,0); }
            to   { transform:translate3d(101%,0,0); }
        }
        @keyframes shine-spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }

        .rz-beast {
            --rz-black: #000000;
            --rz-red: #ED1C24;
            --rz-red-hover: #FF3A42;
            --rz-red-glow: rgba(237,28,36,0.35);
            --rz-surface: #111115;
            --rz-surface-2: #151515;
            --rz-surface-3: #1C1C1E;
            --rz-surface-4: #0E0E0E;
            --rz-border: #232323;
            --rz-border-2: #2A2A2A;
            --rz-border-3: #3A3A3C;
            --rz-text: #ffffff;
            --rz-text-muted: #8A8A8A;
            --rz-text-dim: #9C9C9C;
            --rz-text-faint: #6E6E72;
            --rz-green: #2FBF71;
            font-family: 'Poppins', sans-serif;
            -webkit-font-smoothing: antialiased;
            background: var(--rz-black);
            color: var(--rz-text);
        }

        .rz-beast * { box-sizing: border-box; }
        .rz-beast a { color: var(--rz-text); text-decoration: none; }
        .rz-beast a:hover { color: var(--rz-red); }
        .rz-beast ::-webkit-scrollbar { width: 0; height: 0; }
    `;
    document.head.appendChild(style);
}
